import { render } from "./ChangeViewSwitch.vue?vue&type=template&id=50669644"
import script from "./ChangeViewSwitch.ts?vue&type=script&lang=js"
export * from "./ChangeViewSwitch.ts?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__